import React from 'react'
import classNames from 'classnames'
import { siteNames } from '../../../common/constants/siteList'

const PageOffSitesMenu = ({isOpen, currentSite}) => {
  const className = classNames('off-canvas-left__sites', {
    'fds-u-is-hidden': !isOpen
  })

  const sitesFilter = (siteName) => {
    return [currentSite, 'activeden'].indexOf(siteName) === -1
  }

  return (
    <div className={className}>
      {siteNames.filter(sitesFilter).map((siteName, index) => {
        return (
          <a key={index} href={`https://${siteName}.net/`} className='off-canvas-left__site'>
            <span className={`off-canvas-left__site-logo--${siteName}`}>
              {siteName}
            </span>
            <i className='e-icon -icon-right-open' />
          </a>
        )
      })}
    </div>
  )
}

export default PageOffSitesMenu



// WEBPACK FOOTER //
// ./client/components/pageOffCanvasLeft/pageOffSitesMenu.js